<template>
  <div class="user-header" :class="userClass">
    <edi-partner
      :showPartnerHeader="showPartnerHeader"
      :partnerUrl="partnerUrl"
      :partnerText="getPartnerText"
      :datalayerSubscriptionParams="getDatalayerSubscriptionParams"
      :btnClass="getPartnertClass"
    />

    <edi-login
      :urls="urls"
      :loginText="loginText"
      :menuClass="getMenuClass"
    />

    <edi-payment-toast
      :expiredCardUrl="expiredCardUrl"
      :shoppingCartUrl="shoppingCartUrl"
      :gracePeriodUrl="gracePeriodUrl"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EdiPartner from './EdiPartner.vue';
import EdiLogin from './EdiLogin.vue';
import EdiPaymentToast from './EdiPaymentToast.vue';

export default {
  name: 'edi-user',
  components: {
    EdiPartner,
    EdiLogin,
    EdiPaymentToast,
  },
  props: {
    loginText: String,
    partnerUrl: String,
    partnerText: String,
    reactiveQuotaText: String,
    urls: Array,
    expiredCardUrl: String,
    shoppingCartUrl: String,
    gracePeriodUrl: String,
  },
  computed: {
    ...mapGetters([
      'isLogged',
      'isPartner',
      'showPartnerHeader',
      'isExPartner',
    ]),
    userClass() {
      let userClass = [];

      if (this.isLogged) {
        userClass.push('is-logged');
      }
      if (this.isPartner) {
        userClass.push('is-partner');
      }
      if (this.isExPartner) {
        userClass.push('is-ex-socio');
      }

      if (userClass.length) {
        return userClass.join(' ');
      }

      return null;
    },
    getPartnerText() {
      return this.isExPartner ? this.reactiveQuotaText : this.partnerText;
    },
    getPartnertClass() {
      return this.isExPartner ? 'btn-reactive-quota' : 'btn-partner';
    },
    getMenuClass() {
      return this.isExPartner ? 'menu-reactive-quota' : (this.showPartnerHeader ? 'menu-partner' : '');
    },
    getDatalayerSubscriptionParams() {
      return {
        im_location: this.isExPartner ? 'reactivar_cuenta_header' : 'header',
        im_type: 'infoLibre'
      }
    },
  },
}
</script>
